import React from 'react';
import { Badge } from 'antd';
import Translate from 'react-translate-component';

export const DocumentTabHeader = ({ docsCount }) => (
    <div>
        <span className="doc-tab-header">
            <Translate content="common.attachments" />
            <Badge
                count={docsCount}
                overflowCount={999}
            />
        </span>
    </div>
);
